import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ActionIcon, Avatar, Divider } from '@mantine/core';
import { Trash } from 'tabler-icons-react';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';
import { Context as AuthContext } from '../../../providers/AuthContextProvider';
import { Context as AdminContext } from '../../../providers/AdminContextProvider';
import SearchInput from '../../common/SearchInput';
import AppFlexbox from '../../common/AppFlexbox';

const StoreCreationAssignAdminsStep = ({
  loading,
  createOptions,
  formState,
  setFormState
}) => {
  const { state: authState } = useContext(AuthContext);
  const { searchForUsers } = useContext(AdminContext);

  const onSearchUsers = (
    { searchTerm },
    onSuccessCallback,
    onErrorCallback
  ) => {
    searchForUsers(
      { searchTerm, skipStateUpdate: true },
      (users) =>
        onSuccessCallback(
          users.map((u) => ({
            forceImage: true,
            image: u.avatar,
            label: u.name,
            description: u.email,
            value: u.pkUser,
            data: u
          }))
        ),
      onErrorCallback
    );
  };

  return (
    <AppStack style={{ gap: 10, paddingTop: 10 }}>
      <AppStack style={{ gap: 5 }}>
        <SearchInput
          onSearch={onSearchUsers}
          onSelect={(v, item) => {
            if (!formState.admins.find((a) => a.pkUser === item.data.pkUser)) {
              setFormState((prevState) => ({
                ...prevState,
                admins: [...prevState.admins, item.data]
              }));
            }
          }}
          placeholder="Search by name or full email..."
        />
        <AppStack style={{ padding: 0, gap: 0, border: 'solid 1px lightgrey' }}>
          {formState.admins.length === 0 ? (
            <AppStack style={{ padding: '40px 20px' }}>
              <AppText
                style={{
                  fontSize: 14,
                  color: '#666',
                  textAlign: 'center',
                  fontStyle: 'italic'
                }}
              >
                No users assigned as admin.
              </AppText>
            </AppStack>
          ) : (
            formState.admins.map((a, index) => (
              <React.Fragment key={a.pkUser}>
                {index > 0 && <Divider />}
                <AppFlexbox
                  style={{
                    gap: 0,
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: 8
                  }}
                >
                  <AppFlexbox style={{ alignItems: 'center', gap: 8 }}>
                    <Avatar color="dark" size="md" src={a.avatar} />
                    <AppStack style={{ gap: 0 }}>
                      <AppText style={{ fontSize: 14, fontWeight: 500 }}>
                        {a.name}
                      </AppText>
                      <AppText style={{ fontSize: 14, color: '#666' }}>
                        {a.email}
                      </AppText>
                    </AppStack>
                  </AppFlexbox>

                  {a.pkUser !== authState.userData.user.pkUser && (
                    <AppFlexbox>
                      <ActionIcon
                        color="red"
                        onClick={() => {
                          setFormState({
                            ...formState,
                            admins: [
                              ...formState.admins.filter(
                                (f) => f.pkUser !== a.pkUser
                              )
                            ]
                          });
                        }}
                        variant="subtle"
                      >
                        <Trash size={18} />
                      </ActionIcon>
                    </AppFlexbox>
                  )}
                </AppFlexbox>
              </React.Fragment>
            ))
          )}
        </AppStack>
      </AppStack>
    </AppStack>
  );
};

StoreCreationAssignAdminsStep.propTypes = {
  createOptions: PropTypes.object,
  formState: PropTypes.object,
  loading: PropTypes.bool,
  setFormState: PropTypes.func
};

export default StoreCreationAssignAdminsStep;
